import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]华贵30Tab下基金信息列表
 */
export function getFundInfoListUsingPOST_1(req: HG30Dto | void, config?: RequestConfig): Promise<ApiResultHG30MoreDto> {
  return resource.postNoAuth('/hg30/fundInfoList', req, config);
}

/**
 * [No Auth]华贵30Tab列表
 */
export function getTabInfosUsingPOST_1(req: void, config?: RequestConfig): Promise<ApiResultListTabInfo4HG30> {
  return resource.postNoAuth('/hg30/tabInfo', req, config);
}

/**
 * [No Auth]华贵30首页列表
 */
export function getTabListUsingPOST_1(req: void, config?: RequestConfig): Promise<ApiResultModelInfo4HG30> {
  return resource.postNoAuth('/hg30/tabList', req, config);
}
